export enum Method {
  Z_TEST = 'Z_TEST',
  GST_Z_TEST = 'GST_Z_TEST',
  ASYMP_CS = 'ASYMP_CS',
  RATIO = 'RATIO',
  GST_RATIO = 'GST_RATIO',
  ASYMP_CS_RATIO = 'ASYMP_CS_RATIO',
  QUANTILE = 'QUANTILE',
  GST_QUANTILE = 'GST_QUANTILE',
  ASYMP_CS_QUANTILE = 'ASYMP_CS_QUANTILE',
  CHI2 = 'CHI2',
  UNKNOWN = 'UNKNOWN',
}

export const METHOD_LABELS: Partial<Record<Method, string>> = {
  [Method.Z_TEST]: 'Z-test',
  [Method.RATIO]: 'Z-test with delta method',
  [Method.GST_Z_TEST]: 'Group sequential z-test',
  [Method.GST_RATIO]: 'Group sequential z-test with delta method',
  [Method.ASYMP_CS]: 'Always-valid z-test',
  [Method.ASYMP_CS_RATIO]: 'Always-valid z-test with delta method',
  [Method.CHI2]: 'Chi-squared',
};

export const getMethodLabel = (method: string): string | undefined =>
  METHOD_LABELS[method as Method];

export enum MetricDirection {
  METRIC_DIRECTION_UNSPECIFIED = 'METRIC_DIRECTION_UNSPECIFIED',
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE',
}
